import React, { Component } from "react";
import Header from "../components/Header";
import {
  Twitter,
  Hash,
  Globe,
  Bookmark,
  Linkedin,
  Home,
  ArrowLeftCircle,
  ArrowLeft,
} from "react-feather";
import moment from "moment";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

export default class Countdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errormsg: "",
      nextdata: [],
      reverse: false,
      countdown: "",
    };
  }

  fetchData = () => {
    fetch("https://api.spacexdata.com/v3/launches/next")
      .then((response) => {
        if (response.status !== 200) {
          if (response.status == 429) {
            this.setState({
              isLoading: true,
              errormsg:
                "We're currently experiencing high loads. Please try refreshing.",
            });
          } else {
            this.setState({
              isLoading: true,
              errormsg:
                "We couldn't fetch the data. Status code: " + response.status,
            });
          }
          return;
        }

        // Examine the text in the response
        response.json().then((data) => {
          this.setState({
            nextdata: data,
            isLoading: false,
            errormsg: "",
          });
          this.startCount();
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  };

  startCount = () => {
    const { nextdata } = this.state;
    if (!this.state.isLoading || nextdata.launch_date_unix !== undefined) {
      // const eventTime = moment(nextdata.launch_date_utc).unix();
      // var currentTime = moment().unix();
      // var time = eventTime - currentTime;
      // var duration = moment.duration(time * 1000, "milliseconds");
      // var interval = 1000;

      this.interval = setInterval(() => {
        var then = moment(nextdata.launch_date_utc);
        var now = moment();
        var c = moment(then - now);
        var duration = c.format("DD:HH:mm:ss");

        this.setState({ countdown: duration });
        // duration = moment.duration(
        //   duration.asMilliseconds() - interval,
        //   "milliseconds"
        // );

        // this.setState({
        //   countdown: moment(duration.asMilliseconds()).format(
        //     "H[h]:mm[m]:ss[s]"
        //   ),
        // });
      }, 1000);
    }
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    this.fetchData();
  }

  render() {
    const { isLoading, nextdata, errormsg, countdown } = this.state;

    if (isLoading || errormsg) {
      return (
        <>
          <Header />
          <section class="hero is-black is-fullheight">
            <div class="hero-body">
              <div class="container has-text-centered">
                {errormsg ? (
                  <>
                    <h1 className="title is-5 has-text-white">
                      SpaceX Tracker
                    </h1>
                    <p>{errormsg}</p>
                    <br />
                    <button
                      onClick={() => {
                        window.location.reload();
                      }}
                      className="button is-dark"
                      style={{ marginBottom: "25px" }}
                    >
                      Try again
                    </button>
                    <br />
                    <a href="https://www.twitter.com/ingusjan" target="_blank">
                      <Twitter size={18} />
                    </a>
                  </>
                ) : (
                  <p style={{ opacity: "0.2" }}>Loading</p>
                )}
              </div>
            </div>
          </section>
        </>
      );
    }

    return (
      <>
        <div style={{ position: "absolute", left: "30px", top: "30px" }}>
          <Link to="/" className="has-text-centered">
            <ArrowLeft size={30} color="gray" />
          </Link>
        </div>

        <div style={{ position: "block" }}>
          <div
            id="first"
            className="backgroundImgFade"
            style={{
              margin: "0 auto",
              backgroundImage: `url("${
                nextdata.links != undefined && nextdata.links.mission_patch
              }")`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "center bottom",
              marginTop: "50px",
            }}
          ></div>
          <div
            id="second"
            className="has-text-centered"
            style={{ margin: "0 auto", marginTop: "175px", width: "100%" }}
          >
            <div className="has-text-centered">
              <p>Launch in exactly...</p>
              <h1 id="titleCountDown" className="title is-1 has-text-white">
                {countdown}
              </h1>
            </div>
            <h2
              className="title is-5 has-text-centered"
              style={{ marginTop: "20px", zIndex: "5", color: "#717171" }}
            >
              {nextdata.mission_name}
            </h2>

            <div style={{ marginTop: "80px" }}>
              <a href="https://www.twitter.com/ingusjan" target="_blank">
                <Twitter size={18} />
              </a>
              <a
                style={{ marginLeft: "10px" }}
                href="https://www.linkedin.com/in/ingus-jansons/"
                target="_blank"
              >
                <Linkedin size={18} />
              </a>
            </div>

            <p
              className="help"
              style={{
                opacity: "0.2",
                width: "80%",
                margin: "0 auto",
                textAlign: "center",
                marginTop: "20px",
              }}
            >
              {nextdata.details}
            </p>
          </div>
        </div>
      </>
    );
  }
}
